var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"subtitle":_vm.subtitle,"title":"Fatores de risco","type":"fieldset"}},[_c('Form',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }